<!-- Angular versiyon geçişinden dolayı bu ngx-shimmer-loading modülü Angular 13 versiyonunu desteklemediği için kapatıldı. -->
<!-- <div class="grid grid-nogutter">
    <p-card *ngFor="let param of getEmptyArrayWithSize()" class="col-3 pl-3">
        <ngx-shimmer-loading class="ui-fa-header" [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading class="ui-fa-header" [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading class="ui-fa-header" [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading class="ui-fa-header" [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
    </p-card>
</div> -->
